import { put, takeLatest, call } from 'redux-saga/effects';
import { Action } from 'redux-actions';

import PublicationsPage from '@interfaces/publications-page';
import PublicationFilters from '@interfaces/publication-filters';
import { redirectToNotFound } from 'client/helpers/redirectTo';

import * as actions from './actions';
import * as types from './types';
import * as service from './service';

function* fetchPublicationsPage(action: Action<any>) {
    try {
        const { page, year, themeSlug } = action.payload;
        const data: PublicationsPage = yield call(service.fetchPublicationsPage, { page, year, themeSlug });

        yield put(actions.fetchPublicationsPageSuccess(data));
    } catch (error) {
        yield put(actions.fetchPublicationsPageError(error.message));
        yield put(redirectToNotFound());
    }
}

function* fetchPublicationsByResearcherPage(action: Action<any>) {
    try {
        const { id, page } = action.payload;
        const data: PublicationsPage = yield call(service.fetchPublicationsByResearcherPage, id, page);

        data.params = { id };
        yield put(actions.fetchPublicationsByResearcherPageSuccess(data));
    } catch (error) {
        yield put(actions.fetchPublicationsByResearcherPageError(error.message));
    }
}

function* fetchPublication(action: Action<any>) {
    try {
        const { id } = action.payload;
        const data: PublicationsPage = yield call(service.fetchPublication, id);

        yield put(actions.fetchPublicationSuccess(data));
    } catch (error) {
        yield put(actions.fetchPublicationError(error.message));
        yield put(redirectToNotFound());
    }
}

function* fetchPublicationYears(action: Action<any>) {
    try {
        const { themeSlug } = action.payload;
        const data: PublicationFilters = yield call(service.fetchPublicationYears, themeSlug);

        yield put(actions.fetchPublicationYearsSuccess({ ...data, themeSlug }));
    } catch (error) {
        yield put(actions.fetchPublicationYearsError(error.message));
    }
}

export default function* appSaga() {
    yield takeLatest(types.FETCH_PUBLICATIONS_PAGE, fetchPublicationsPage);
    yield takeLatest(types.FETCH_PUBLICATIONS_BY_RESEARCHER_PAGE, fetchPublicationsByResearcherPage);
    yield takeLatest(types.FETCH_PUBLICATION, fetchPublication);
    yield takeLatest(types.FETCH_PUBLICATION_YEARS, fetchPublicationYears);
}
